"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var UIEventImpl = require("./UIEvent-impl").implementation;

var MouseEventImpl = /*#__PURE__*/function (_UIEventImpl) {
  _inherits(MouseEventImpl, _UIEventImpl);

  function MouseEventImpl() {
    _classCallCheck(this, MouseEventImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MouseEventImpl).apply(this, arguments));
  }

  _createClass(MouseEventImpl, [{
    key: "initMouseEvent",
    value: function initMouseEvent(type, bubbles, cancelable, view, detail, screenX, screenY, clientX, clientY, ctrlKey, altKey, shiftKey, metaKey, button, relatedTarget) {
      if (this._dispatchFlag) {
        return;
      }

      this.initUIEvent(type, bubbles, cancelable, view, detail);
      this.screenX = screenX;
      this.screenY = screenY;
      this.clientX = clientX;
      this.clientY = clientY;
      this.ctrlKey = ctrlKey;
      this.altKey = altKey;
      this.shiftKey = shiftKey;
      this.metaKey = metaKey;
      this.button = button;
      this.relatedTarget = relatedTarget;
    }
  }]);

  return MouseEventImpl;
}(UIEventImpl);

module.exports = {
  implementation: MouseEventImpl
};